export const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
